export default {
    /* Verdikort */
    valueCardTitle: 'Verdikort',
    valueCardIngress: 'Her kan du bestille verdikort',
    valueCardLinkText: 'Klikk her for å gå til verdikortbestilling',
    valueCardLinkSubText: 'Åpnes i nytt vindu',
    valueCardError: 'Vi beklager! Vi kunne ikke gjennomføre tjenesten akkurat nå. Vennligst prøv igjen senere.',

    valueProgramDiscountAmount: 'Opptjent rabatt',
    valueProgramYour: 'Ditt',
    valueProgramName: 'Verdiregnskap',
    valueProgramTransactionHistory: 'Rabattkjøp',
    valueProgramChooseYear: 'Velg år',
    valueProgramDiscountEarned: 'Opptjent rabatt i',
    valueProgramCurrentPeriod: 'denne perioden',
    valueProgramTotalDiscountCurrentYear: 'Total rabatt hittil i år',
    valueProgramDiscountPayout: 'Rabatt utbetales',
    valueProgramDiscountType: 'Type rabatt',
    valueProgramChooseCategory: 'Filtrer rabattkjøp',
    valueProgramChooseCategorySubtitle: 'Kategorier',
    valueProgramTotalBonusInfoHeader: 'Total rabatt',
    valueProgramTotalBonusInfo:
        'Her vises all rabatt du har opptjent hittil i år. Dette inkluderer rabatt ved fylling av drivstoff hos Circle K, som har blitt trukket fra direkte på pumpe.',
    valueProgramTotalBonusImageAlt: 'Lyspære',
    valueProgramBonusInfoModalClose: 'Ok',
    valueProgramDiscountFilterSave: 'Ok',
    valueProgramAllProviders: 'Alle kategorier',
    valueProgramYouPaidPrefix: 'Du betalte',

    valueProgramRegistrationFormHeader: 'Få ekstra gode fordeler med ditt Eika Kredittkort',
    valueProgramRegistrationDiscountHeader: 'Opptjen rabatter',
    valueProgramRegistrationFormPricesHeader: 'Vilkår og pris',
    valueProgramRegistrationFormInfo1:
        'Å få faste rabatter og benytte seg av eksklusive kampanjer har aldri vært enklere. Det eneste du behøver å gjøre er å registrere deg her.',
    valueProgramRegistrationFormInfo2:
        'Deretter får du tilsendt regelmessig informasjon om tilbud og kampanjer på e-post.',
    valueProgramRegistrationFormInfo3:
        'Rabattene du opptjener underveis utbetales tilbake til ditt Eika Kredittkort én gang i måneden.',
    valueProgramRegistrationFormInfo3More:
        'Du vil få tilsendt regelmessig informasjon om tilbud og kampanjer på e-post.',
    valueProgramRegistrationFormInfo4:
        'Du kan maksimalt opptjene kr 500 i rabatt per måned, og kr 2.500 per kalenderår.',
    valueProgramRegistrationFormInfo5:
        'Påmeldingen koster ingenting, er ikke bindende og du kan når som helst velge å melde deg av.',
    valueProgramRegistrationFormInfo6:
        'Husk å betale kredittkortregningen til forfall, da får du best utbytte av tilbudene.',
    valueProgramRegistrationFormInfo7:
        'Effektiv rente ved utsatt betaling med Eika Kredittkort: 25,29 % v/15.000,- o/12 mnd. Kostnad 1.851,39 kr. Totalt 16.851,39 kr.',
    valueProgramRegistrationFormPriceInfo: 'Se prisliste for kredittkort her',
    valueProgramRegistrationFormSubmit: 'Meld meg på',
    valueProgramRegistrationFormResignation: 'Meld meg av Fordelsprogrammet',
    valueProgramRegistrationFormSubmitted: 'Du er påmeldt!',
    valueProgramDiscountsEmptyText: 'Ingen rabatt å vise',

    valueProgramRequestErrorMessage: 'Noe gikk galt. Prøv igjen. Hvis problemet vedvarer - vennligst kontakt oss.',

    valueProgramRegistrationFormMissingInformation: 'Noe gikk galt under henting av kontoinformasjon.',
    valueProgramNoMoreDiscountTransactions: 'Det var alle transaksjonene på denne kontoen.',

    valueProgramAddendumTypeNotFound: 'Fant ikke addendumtype',
    valueProgramAddendumFuelType: 'Drivstoff',
    valueProgramAddendumQuantity: 'Liter',
    valueProgramAddendumVatAmount: 'Herav mva',
    valueProgramAddendumDiscount: 'Rabatt /l',
    valueProgramAddendumDiscountAmount: 'Rabatt',
    valueProgramAddendumDetails: 'Detaljer',
    valueProgramAddendumProduct: 'Produkt',
    valueProgramAddendumUnitPrice: 'Pris',
    valueProgramAddendumTotalPrice: 'Totalt',
    valueProgramAddendumTotalDiscount: 'Tot. rabatt',

    valueProgramAgriCircleKYxPdfExport: 'Oversikt Circle K / YX (PDF)',
    valueProgramExportDiscountsHeading: 'Oversikt Circle K / YX (PDF)',
    valueProgramExportDiscountsType: 'Type',
    valueProgramExportDiscountsPeriod: 'Periode',
    valueProgramExportDiscountsExportButton: 'Hent oversikt (PDF)',
};
